export default __webpack_public_path__ + "static/media/product-bg.6c65b340.webp";